import React, { useEffect } from "react";
import { initializeMetaPixel, META_PIXEL_ID } from "../analytics/metaPixel";

/** Initializes Meta Pixel and records the landing-page visit once. */
export function MetaPixel() {
  useEffect(() => {
    initializeMetaPixel();
  }, []);
  return <noscript data-id="element-119" data-mp="1f88j3khxnqph">
      <img height="1" width="1" style={{
      display: "none"
    }} src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} alt="" data-id="element-120" data-mp="1jbdjnhigdibh" />
    </noscript>;
}